import React from 'react';
import { ServiceScheduleType, Workplace } from '../../../../graphql/graphql';
import CaseTypeList from '../../../Manager/Components/CaseType/List/CaseTypeList';
import { ServiceScheduleContextProvider } from '../../../WorkplaceMember/Services/ServiceScheduleContext';
import ServiceScheduleCalendar from '../../../Calendar/Components/ServiceScheduleCalendar/ServiceScheduleCalendar';
import WorkplaceOrderingSettingsCalendar from '../../../../Components/Calendar/WorkplaceOrderingSettingsCalendar';
import ORSMWorkplaceOrderingRestrictionSettings from './ORSMWorkplaceOrderingRestrictionSettings';

export enum ORSMWorkplaceSettingsType {
	CASE_TYPES = 'caseTypes',
	ONLINE_ORDERING = 'onlineOrdering',
	SHIFTS = 'shifts',
	RESTRICTION = 'restriction',
}

interface Props {
	type: ORSMWorkplaceSettingsType;
	workplace: Workplace;
	changeType: (type: ORSMWorkplaceSettingsType) => void;
	onClose: () => void;
	onWorkplaceUpdate: () => Promise<void>;
}

const ORSMWorkplaceSettings: React.FC<Props> = ({
	type,
	workplace,
	changeType,
	onClose,
	onWorkplaceUpdate,
}) => {
	const onUpdate = async () => {
		await onWorkplaceUpdate();
		onClose();
	};

	switch (type) {
		case ORSMWorkplaceSettingsType.CASE_TYPES:
			return (
				<CaseTypeList
					workplaceId={workplace.id}
					openShifts={() => changeType(ORSMWorkplaceSettingsType.SHIFTS)}
				/>
			);
		case ORSMWorkplaceSettingsType.SHIFTS:
			return (
				<ServiceScheduleContextProvider workplaceId={workplace.id}>
					<ServiceScheduleCalendar
						scheduleTypes={[
							ServiceScheduleType.Shift,
							ServiceScheduleType.ShiftExtra,
						]}
						workplaceId={workplace.id}
						navigateToOnlineOrdering={() =>
							changeType(ORSMWorkplaceSettingsType.ONLINE_ORDERING)
						}
					/>
				</ServiceScheduleContextProvider>
			);
		case ORSMWorkplaceSettingsType.ONLINE_ORDERING:
			return (
				<WorkplaceOrderingSettingsCalendar
					workplaceId={workplace.id}
					openShifts={() => changeType(ORSMWorkplaceSettingsType.SHIFTS)}
				/>
			);
		case ORSMWorkplaceSettingsType.RESTRICTION:
			return (
				<ORSMWorkplaceOrderingRestrictionSettings
					workplace={workplace}
					onUpdate={onUpdate}
				/>
			);
	}
};

export default ORSMWorkplaceSettings;
